export default "__VITE_ASSET__pTy$1fVV__"